<template>
  <b-row>
    <b-col>
      <b-card class="p-1 p-md-3">

        <b-card-title>
          {{ $t('deposit-text') }}
        </b-card-title>
        <b-row v-if="ENABLED_CRYPTO_ONLINE_BANK_DEPOSIT">
          <b-col sm="12">
            <b-alert
              variant="success"
              show
            >

              <div class="alert-body p-2">
                <h4>
                  {{ $t('deposit-alert-text') }}
                </h4>
              </div>
            </b-alert>

          </b-col>
        </b-row>
        <b-row>
          <div class="d-flex flex-column flex-md-row  w-100 justify-content-center align-items-center">
            <b-button
              v-if="ENABLED_CRYPTO_ONLINE_BANK_DEPOSIT"
              class="d-flex justify-content-center align-items-center btn-style "
              variant="success"
              :to="`/${$i18n.locale}/customer-wallets/fiat/deposit/online`"
            >
              <div>
                <h4 class="text-white">
                  {{ $t('bank_deposit') }}
                </h4>
                <span>{{ '('+$t('online-payment')+')' }}</span>
              </div>
            </b-button>
            <b-button
              v-if="ENABLED_CRYPTO_MEMO_BANK_DEPOSIT"
              class="d-flex justify-content-center align-items-center btn-style "
              variant="success"
              :to="`/${$i18n.locale}/customer-wallets/fiat/deposit/memo`"
            >
              <div>
                <h4 class="text-white">
                  {{ $t('bank_deposit') }}
                </h4>
                <span>{{ '('+$t('memo_bank_deposit')+')' }}</span>
              </div>
            </b-button>
            <b-button
              v-if="ENABLED_CRYPTO_WIRE_BANK_DEPOSIT"
              class="d-flex justify-content-center align-items-center btn-style"
              variant="success"
              :to="`/${$i18n.locale}/customer-wallets/fiat/deposit`"
            >
              <div>
                <h4 class="text-white">
                  {{ $t('fiat_Deposit') }}
                </h4>
                <span>{{ '('+$t('bank-receipt')+')' }}</span>
              </div>
            </b-button>

            <b-button
              class="d-flex justify-content-center align-items-center btn-style "
              variant="info"
              :to="`/${$i18n.locale}/crypto-wallets`"
            >
              <h4 class="text-white">
                {{ $t('crypto Deposit') }}
              </h4>
            </b-button>

          </div>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import Deposit from '@/modules/crypto/views/logic/customer-wallets/fiat/Deposit'

export default {
  mixins: [Deposit],
}
</script>
<style>
.btn-style {
  margin: 5px;
  width: 100%;
  height: 100px;
}
</style>
